import { render } from "./ViewOuvFermPage.vue?vue&type=template&id=26fb9773&ts=true"
import script from "./ViewOuvFermPage.vue?vue&type=script&lang=ts"
export * from "./ViewOuvFermPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__